import { useState } from 'react'
import { useSelector } from 'react-redux'
import {
  Grid,
  IconButton,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import PlaceIcon from '@mui/icons-material/Place'
import DeleteIcon from '@mui/icons-material/Delete'
import SportsIcon from '@mui/icons-material/Sports'
import WarningIcon from '@mui/icons-material/Warning'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

import Button from '../components/Button'
import Dialog from '../components/Dialog'
import Select from '../components/Select'
import GridHeader from '../components/GridHeader'
import DialogOmologa from '../components/DialogOmologa'
import DialogPenalita from '../components/DialogPenalita'
import DialogIndirizzo from '../components/DialogIndirizzo'
import DialogRisultato from '../components/DialogRisultato'
import DialogCalendario from '../components/DialogCalendario'
import DialogArbitraggio from '../components/DialogArbitraggio'
import DialogRipescaggio from '../components/DialogRipescaggio'
import DialogUploadCalendari from '../components/DialogUploadCalendari'
import SelectionBar from '../components/selection/SelectionBar'
import ButtonDownload from '../components/ButtonDownload'
import ButtonRunDownload from '../components/ButtonRunDownload'
import SortableTableHead from '../components/SortableTableHead'
import GridCircularProgress from '../components/GridCircularProgress'
import { config } from '../settings/configs'
import {
  colours,
  titlesCalendari as titles,
  phrasesCalendari as phrases,
} from '../settings/settings'
import { useFeedback } from '../hooks/feedback-hook'
import {
  useGetCalendariQuery,
  useUpdateCalendarioMutation,
  useUpdateCalendarioDataOraMutation,
  useDeleteCalendarioMutation,
  useGetDesignazioniAcceptedQuery,
  useGetIscrizioniQuery,
  useGetSpostamentiWaitingQuery,
} from '../hooks/api-slice'
import { sortCalendari } from '../hooks/sort-functions'
import { getCategorie, getGironi } from '../hooks/selection-get-functions'
import { filterByMissingInfo } from '../hooks/utils-functions'

const Calendari = () => {
  const { admin, designatore, omologatore } = useSelector(
    state => state.home.infoUtente,
  )
  const selectedCampionatoCalendariPubblicati = useSelector(
    state => state.selection.selectedCampionatoCalendariPubblicati,
  )
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const availableCategorie = useSelector(
    state => state.selection.availableCategorie,
  )
  const selectedCategoria = useSelector(
    state => state.selection.selectedCategoria,
  )
  const availableGironi = useSelector(state => state.selection.availableGironi)
  const selectedGirone = useSelector(state => state.selection.selectedGirone)
  const selectedTeam = useSelector(state => state.selection.selectedTeam)
  const selectedNumeroGara = useSelector(
    state => state.selection.selectedNumeroGara,
  )

  const skipQueries = !(
    selectedCampionato &&
    (admin || selectedCampionatoCalendariPubblicati)
  )

  const { data: iscrizioni, isLoading: isLoadingI } = useGetIscrizioniQuery(
    { campionato: selectedCampionato },
    { skip: skipQueries },
  )
  const { data: calendari, isLoading: isLoadingC } = useGetCalendariQuery(
    { selectedCampionato },
    { skip: skipQueries },
  )
  const { data: waitingSpostamenti } = useGetSpostamentiWaitingQuery(
    selectedCampionato,
    { skip: skipQueries },
  )

  const { data: acceptedDesignazioni } = useGetDesignazioniAcceptedQuery(
    selectedCampionato,
    { skip: skipQueries },
  )

  const [updateCalendarioMutation] = useUpdateCalendarioMutation()
  const [updateCalendarioDataOraMutation] = useUpdateCalendarioDataOraMutation()
  const [deleteCalendarioMutation] = useDeleteCalendarioMutation()

  document.title = `${config?.name} - Calendari`

  const { setFeedback } = useFeedback()

  let columnsCalendari = [
    { label: 'Gara', sortable: false },
    { label: 'Giornata', sortable: false },
    { label: 'Data', sortable: false },
    { label: 'Ora', sortable: false },
    { label: 'Indirizzo', sortable: false },
    { label: 'Squadra in casa', sortable: false },
    { label: 'Squadra in trasferta', sortable: false },
    { label: 'Risultato', sortable: false },
    { label: 'Parziali', sortable: false },
  ]
  if (admin) {
    columnsCalendari = [
      ...columnsCalendari,
      { label: 'Opzioni', sortable: false },
    ]
  }

  const FILTERS = ['Tutte', 'Senza data', 'Da giocare']
  const [selectedFilter, setSelectedFilter] = useState(FILTERS[0])

  const [openEditCalendario, setOpenEditCalendario] = useState()
  const [openEditRisultato, setOpenEditRisultato] = useState()
  const [openEditPenalita, setOpenEditPenalita] = useState()
  const [openEditOmologa, setOpenEditOmologa] = useState()
  const [openEditArbitraggio, setOpenEditArbitraggio] = useState()
  const [openEditRipescaggio, setOpenEditRipescaggio] = useState()
  const [openDeleteGara, setOpenDeleteGara] = useState()
  const [openCarica, setOpenCarica] = useState()
  const [openIndirizzo, setOpenIndirizzo] = useState()

  const [editCalendario, setEditCalendario] = useState()
  const [editRisultato, setEditRisultato] = useState()
  const [editPenalita, setEditPenalita] = useState()
  const [editOmologa, setEditOmologa] = useState()
  const [editArbitraggio, setEditArbitraggio] = useState()
  const [editRipescaggio, setEditRipescaggio] = useState()
  const [deletingId, setDeletingId] = useState()

  const handleClickOpenEditCalendario = id => {
    setEditCalendario(calendari.find(i => i.id === id))
    setOpenEditCalendario(true)
  }

  const handleClickOpenEditRisultato = id => {
    setEditRisultato(calendari.find(i => i.id === id))
    setOpenEditRisultato(true)
  }

  const handleClickOpenEditPenalita = id => {
    setEditPenalita(calendari.find(i => i.id === id))
    setOpenEditPenalita(true)
  }

  const handleClickOpenEditOmologa = id => {
    setEditOmologa(calendari.find(i => i.id === id))
    setOpenEditOmologa(true)
  }

  const handleClickOpenEditArbitraggio = id => {
    setEditArbitraggio(calendari.find(i => i.id === id))
    setOpenEditArbitraggio(true)
  }

  const handleClickOpenRipescaggio = id => {
    setEditRipescaggio(calendari.find(i => i.id === id))
    setOpenEditRipescaggio(true)
  }

  const handleClickOpenDeleteGara = id => {
    setDeletingId(id)
    setOpenDeleteGara(true)
  }

  const handleClickOpenCarica = () => setOpenCarica(true)

  const [garaIndirizzo, setGaraIndirizzo] = useState()

  const handleClickOpenIndirizzo = gara => {
    setGaraIndirizzo(gara)
    setOpenIndirizzo(true)
  }

  const handleCloseEditCalendario = () => {
    setOpenEditCalendario()
    setEditCalendario()
  }

  const handleCloseEditRisultato = () => {
    setOpenEditRisultato()
    setEditRisultato()
  }

  const handleCloseEditPenalita = () => {
    setOpenEditPenalita()
    setEditPenalita()
  }
  const handleCloseEditOmologa = () => {
    setOpenEditOmologa()
    setEditOmologa()
  }
  const handleCloseEditArbitraggio = () => {
    setOpenEditArbitraggio()
    setEditArbitraggio()
  }
  const handleCloseEditRipescaggio = () => {
    setOpenEditRipescaggio()
    setEditRipescaggio()
  }

  const handleCloseCarica = () => setOpenCarica()

  const handleCloseDeleteGara = () => {
    setOpenDeleteGara()
    setDeletingId()
  }

  const handleCloseIndirizzo = () => {
    setOpenIndirizzo()
    setGaraIndirizzo()
  }

  const editCalendarioFunction = async (newData, newOra, swapTeams) => {
    let body = { id: editCalendario?._id }
    if (!!newData && !!newOra) {
      body = { ...body, tipologia: 'sposta', data: newData, ora: newOra }
    } else if (!!swapTeams) {
      body = { ...body, tipologia: 'inverti' }
    } else {
      body = { ...body, tipologia: 'sposta' }
    }

    const result = await updateCalendarioDataOraMutation(body)

    if (!result?.error) {
      handleCloseEditCalendario()
      setEditCalendario()
      setFeedback(
        phrases.phraseCalendarioSuccess,
        false,
        titles.titleEditCalendario,
      )
    } else {
      setFeedback(result?.error?.data?.message)
    }
  }

  const updateRisultato = async (id, risultato) => {
    const result = await updateCalendarioMutation({
      id,
      tipologia: 'risultato',
      ...risultato,
    })
    if (!result?.error) {
      handleCloseEditRisultato()
      setEditRisultato()
      setFeedback(
        phrases.phraseRisultatoSuccess,
        false,
        titles.titleEditRisultato,
      )
    }
  }

  const updatePenalita = async (penalitaCasa, penalitaTrasferta) => {
    const result = await updateCalendarioMutation({
      id: editPenalita?.id,
      tipologia: 'penalita',
      penalitaCasa,
      penalitaTrasferta,
    })
    if (!result?.error) {
      handleCloseEditPenalita()
      setEditPenalita()
      setFeedback(
        phrases.phrasePenalitaSuccess,
        false,
        titles.titleEditPenalita,
      )
    }
  }

  const updateOmologa = async omologa => {
    const result = await updateCalendarioMutation({
      id: editOmologa.id,
      tipologia: 'omologa',
      validHomologation: omologa,
    })
    if (!result?.error) {
      handleCloseEditOmologa()
      setEditOmologa()
      setFeedback(phrases.phraseOmologaSuccess, false, titles.titleEditOmologa)
    }
  }

  const updateArbitraggio = async needsReferee => {
    const result = await updateCalendarioMutation({
      id: editArbitraggio?.id,
      tipologia: 'arbitraggio',
      needsReferee,
    })
    if (!result?.error) {
      handleCloseEditArbitraggio()
      setEditArbitraggio()
      setFeedback(
        phrases.phraseArbitraggioSuccess,
        false,
        titles.titleEditArbitraggio,
      )
    }
  }

  const performRipescaggio = async ripescaggioID => {
    const result = await updateCalendarioMutation({
      id: editRipescaggio?.id,
      tipologia: 'ripescaggio',
      squadraID: ripescaggioID,
    })
    if (!result?.error) {
      handleCloseEditRipescaggio()
      setEditRipescaggio()
      setFeedback(
        phrases.phraseRipescaggioSuccess,
        false,
        titles.titleEditRipescaggio,
      )
    }
  }

  const deleteGara = async () => {
    const result = await deleteCalendarioMutation(deletingId)
    if (!result?.error) {
      handleCloseDeleteGara()
      setFeedback(
        phrases.phraseDeleteGaraSuccess,
        false,
        titles.titleDeleteGara,
      )
    }
  }

  const fCalendari = filterByMissingInfo(
    calendari
      ?.filter(
        c =>
          !selectedTeam ||
          c.squadraCasaID === selectedTeam ||
          c.squadraTrasfertaID === selectedTeam,
      )
      ?.filter(c => !selectedNumeroGara || c.numeroGara === selectedNumeroGara),
    FILTERS,
    selectedFilter,
  )?.sort(sortCalendari)

  const CalendariTable = ({ categoria, girone }) => {
    const calendarioTable = fCalendari
      .filter(i => i.categoria === categoria && i.girone === girone)
      .sort(sortCalendari)

    const calendarioTitle =
      girone === 'finali' ? 'Fasi finali' : `Girone ${girone}`

    return (
      <>
        <h4>
          Categoria {categoria} - {calendarioTitle}
        </h4>
        <TableContainer component={Paper}>
          <Table size='small'>
            <SortableTableHead
              table={calendarioTable}
              columns={columnsCalendari.map(c =>
                girone === 'finali' && c.label === 'Giornata'
                  ? { ...c, label: 'Fase' }
                  : c,
              )}
            />
            <TableBody>
              {calendarioTable.map((a, index) => {
                const propsCell = {
                  style: {
                    borderBottomColor:
                      !selectedTeam &&
                      index < calendarioTable.length - 1 &&
                      calendarioTable[index].giornata !==
                        calendarioTable[index + 1].giornata &&
                      colours.greyVeryDark,
                  },
                }

                const needsReferee = !!a.needsReferee
                const requiresReferee = !!a.requiresReferee
                const requiresRefereeAccepted = acceptedDesignazioni?.includes(
                  a.id,
                )
                const isHomologated = !!a.validHomologation

                const aSets =
                  typeof a.setVintiCasa === 'number' &&
                  typeof a.setVintiTrasferta === 'number'
                    ? `${a.setVintiCasa} - ${a.setVintiTrasferta}`
                    : ''

                const aPoints =
                  a.parzialiCasa?.length > 0 &&
                  a.parzialiTrasferta?.length > 0 &&
                  a.parzialiCasa.length === a.parzialiTrasferta.length
                    ? a.parzialiCasa
                        ?.map(
                          (_, i) =>
                            `${a.parzialiCasa[i]}-${a.parzialiTrasferta[i]}`,
                        )
                        .join(' ')
                    : ''

                const aGolden = typeof a.parzialeGoldenCasa === 'number' &&
                  typeof a.parzialeGoldenTrasferta === 'number' && (
                    <b style={{ backgroundColor: colours.goldenSet }}>
                      {a.parzialeGoldenCasa}-{a.parzialeGoldenTrasferta}
                    </b>
                  )

                let fiColor
                let fiTitle
                if (
                  needsReferee ||
                  (requiresReferee && requiresRefereeAccepted)
                ) {
                  fiColor = colours.black
                  fiTitle = 'Arbitro ufficiale'
                } else if (requiresReferee && !requiresRefereeAccepted) {
                  fiColor = colours.blueLight
                  fiTitle = 'Arbitro richiesto'
                } else if (admin || designatore) {
                  fiColor = colours.greyLight
                  fiTitle = 'Arbitro non ufficiale'
                } else {
                  fiColor = 'transparent'
                  fiTitle = ''
                }

                const Fischietto = (
                  <Tooltip title={fiTitle}>
                    <SportsIcon style={{ color: fiColor }} />
                  </Tooltip>
                )

                let propsDate = {}
                if (admin)
                  propsDate = {
                    ...propsDate,
                    sx: { ...propsDate.sx, cursor: 'pointer' },
                    onClick: () => handleClickOpenEditCalendario(a.id),
                  }

                let propsSets = {}
                if (admin || omologatore)
                  propsSets = {
                    sx: { cursor: 'pointer' },
                    onClick: () => handleClickOpenEditRisultato(a.id),
                  }

                let propsPoints = {
                  align:
                    a.parzialiCasa?.length === 1 &&
                    a.parzialiTrasferta?.length === 1 &&
                    !a.parzialeGoldenCasa &&
                    !a.parzialeGoldenTrasferta
                      ? 'center'
                      : 'left',
                }
                if (admin || omologatore)
                  propsPoints = {
                    ...propsPoints,
                    sx: { cursor: 'pointer' },
                    onClick: () => handleClickOpenEditRisultato(a.id),
                  }

                const aSquadraCasaNome = iscrizioni.find(
                  i => i.id === a.squadraCasaID,
                )?.nomeSquadra
                const aSquadraTrasfertaNome = iscrizioni.find(
                  i => i.id === a.squadraTrasfertaID,
                )?.nomeSquadra

                return (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: waitingSpostamenti?.includes(a.id)
                        ? colours.highlight
                        : colours.white,
                      ':hover': { backgroundColor: colours.greyVeryLight },
                    }}
                  >
                    <TableCell {...propsCell}>
                      <Grid
                        container
                        alignItems='center'
                        justifyContent='space-between'
                        sx={{ width: '100%' }}
                      >
                        <Grid>
                          {admin || designatore ? (
                            <IconButton
                              onClick={() =>
                                handleClickOpenEditArbitraggio(a.id)
                              }
                            >
                              {Fischietto}
                            </IconButton>
                          ) : (
                            Fischietto
                          )}
                        </Grid>
                        <Grid>{a.numeroGara}</Grid>
                        <Grid>
                          {(admin || omologatore) && isHomologated && (
                            <IconButton
                              onClick={() => handleClickOpenEditOmologa(a.id)}
                            >
                              <Tooltip title='Referto consegnato'>
                                <CheckCircleIcon
                                  style={{ color: colours.green }}
                                />
                              </Tooltip>
                            </IconButton>
                          )}
                          {(admin || omologatore) && !isHomologated && (
                            <IconButton
                              onClick={() => handleClickOpenEditOmologa(a.id)}
                            >
                              <Tooltip title='Referto non consegnato'>
                                <CheckCircleOutlineIcon
                                  style={{ color: colours.greyLight }}
                                />
                              </Tooltip>
                            </IconButton>
                          )}
                          {!admin && !omologatore && isHomologated && (
                            <Tooltip title='Referto consegnato'>
                              <CheckCircleIcon
                                style={{ color: colours.green }}
                              />
                            </Tooltip>
                          )}
                          {!admin && !omologatore && !isHomologated && (
                            <CheckCircleOutlineIcon
                              style={{ color: 'transparent' }}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </TableCell>
                    <TableCell {...propsCell}>{a.giornata}</TableCell>
                    <TableCell {...propsCell} {...propsDate}>
                      {a.data}
                    </TableCell>
                    <TableCell {...propsCell} {...propsDate}>
                      {a.ora}
                    </TableCell>
                    <TableCell
                      {...propsCell}
                      sx={{ ...propsCell.sx, cursor: 'pointer' }}
                    >
                      <PlaceIcon
                        style={{ color: colours.red }}
                        onClick={() => handleClickOpenIndirizzo(a)}
                      />
                    </TableCell>
                    <TableCell {...propsCell}>
                      {a.squadraCasaID === selectedTeam ? (
                        <b>{aSquadraCasaNome}</b>
                      ) : (
                        aSquadraCasaNome ||
                        (girone === 'finali' &&
                          ((admin && a.squadraCasaID === 'Ripescaggio' && (
                            <>
                              <i>Ripescaggio</i>
                              <IconButton
                                onClick={() => handleClickOpenRipescaggio(a.id)}
                              >
                                <Tooltip title='Scegli una squadra'>
                                  <EditIcon
                                    style={{ color: colours.blueDark }}
                                  />
                                </Tooltip>
                              </IconButton>
                            </>
                          )) || <i>{a.squadraCasaID}</i>)) || (
                          <i>Squadra non trovata</i>
                        )
                      )}
                    </TableCell>
                    <TableCell {...propsCell}>
                      {a.squadraTrasfertaID === selectedTeam ? (
                        <b>{aSquadraTrasfertaNome}</b>
                      ) : (
                        aSquadraTrasfertaNome ||
                        (girone === 'finali' &&
                          ((admin && a.squadraTrasfertaID === 'Ripescaggio' && (
                            <>
                              <i>Ripescaggio</i>
                              <IconButton
                                onClick={() => handleClickOpenRipescaggio(a.id)}
                              >
                                <Tooltip title='Scegli una squadra'>
                                  <EditIcon
                                    style={{ color: colours.blueDark }}
                                  />
                                </Tooltip>
                              </IconButton>
                            </>
                          )) || <i>{a.squadraTrasfertaID}</i>)) || (
                          <i>Squadra non trovata</i>
                        )
                      )}
                    </TableCell>
                    <TableCell {...propsCell} {...propsSets}>
                      {aSets}
                    </TableCell>
                    <TableCell {...propsCell} {...propsPoints}>
                      {aPoints}&nbsp;{aGolden}
                    </TableCell>
                    {admin && (
                      <TableCell {...propsCell}>
                        <Grid container sx={{ width: '100%' }}>
                          <Grid size='grow'>
                            <IconButton
                              style={{ color: colours.blueDark }}
                              onClick={() => handleClickOpenEditPenalita(a.id)}
                            >
                              <Tooltip title='Penalità'>
                                <WarningIcon />
                              </Tooltip>
                            </IconButton>
                          </Grid>
                          <Grid size='grow'>
                            <IconButton
                              style={{ color: colours.red }}
                              onClick={() => handleClickOpenDeleteGara(a.id)}
                            >
                              <Tooltip title='Elimina'>
                                <DeleteIcon />
                              </Tooltip>
                            </IconButton>
                          </Grid>
                        </Grid>
                      </TableCell>
                    )}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    )
  }

  return (
    <Grid container paddingX={2} spacing={2} sx={{ width: '100%' }}>
      <GridHeader h2>Calendari</GridHeader>
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar
          data={calendari}
          yCampionato
          yCategoria
          yGirone
          yTeam
          yNumeroGara={admin || omologatore}
        />
        {admin && (
          <Grid size={{ xs: 12, md: 3 }}>
            <Select
              label='Altri filtri'
              value={selectedFilter}
              options={FILTERS}
              onChange={setSelectedFilter}
            />
          </Grid>
        )}
        {admin && (
          <Grid size={{ xs: 12, md: 'grow' }}>
            <center>
              <Button light onClick={handleClickOpenCarica}>
                Carica Calendari
              </Button>
              <DialogUploadCalendari
                open={openCarica}
                handleClose={handleCloseCarica}
              />
            </center>
          </Grid>
        )}
        {admin && (
          <Grid size={{ xs: 12, md: 'grow' }}>
            <ButtonDownload algorithm='05_UpdateCalendari' type='TXT' />
          </Grid>
        )}
        <Grid size={{ xs: 12, md: 'grow' }}>
          <ButtonRunDownload
            buttonText='Scarica Excel'
            algorithm='08_GenerateExcelCalendari'
            type='XLSX'
            disabled={
              !selectedCampionato ||
              !selectedCategoria ||
              !selectedGirone ||
              selectedCategoria === availableCategorie[0] ||
              (!admin && selectedGirone === availableGironi[0]) ||
              !(admin || selectedCampionatoCalendariPubblicati) ||
              !!selectedNumeroGara
            }
          />
        </Grid>
      </Grid>
      {(!admin &&
        selectedCampionato &&
        !selectedCampionatoCalendariPubblicati && (
          <GridHeader text='Calendari non ancora pubblicati.' />
        )) ||
        ((isLoadingC || isLoadingI) && <GridCircularProgress />) ||
        (selectedCategoria &&
          selectedGirone &&
          ((!fCalendari?.length && (
            <GridHeader>
              Nessuna gara{' '}
              {selectedFilter === FILTERS[1]
                ? 'senza data'
                : selectedFilter === FILTERS[2]
                  ? 'ancora da giocare'
                  : 'da visualizzare'}
              .
            </GridHeader>
          )) ||
            (iscrizioni?.length && (
              <Grid container alignItems='center' sx={{ width: '100%' }}>
                {config?.features?.spostamenti && (
                  <Grid size={{ xs: 12, md: 7 }}>
                    Le gare evidenziate hanno uno spostamento in sospeso.
                  </Grid>
                )}
                <Grid container rowSpacing={3} sx={{ width: '100%' }}>
                  {getCategorie(
                    fCalendari.filter(i =>
                      !!selectedCategoria &&
                      selectedCategoria !== availableCategorie[0]
                        ? i.categoria === selectedCategoria
                        : true,
                    ),
                  ).map(categoria =>
                    getGironi(
                      fCalendari.filter(
                        i =>
                          i.categoria === categoria &&
                          (!!selectedGirone &&
                          selectedGirone !== availableGironi[0]
                            ? i.girone === selectedGirone
                            : true),
                      ),
                    ).map(girone => (
                      <Grid key={`${categoria}-${girone}`} size={12}>
                        <CalendariTable categoria={categoria} girone={girone} />
                      </Grid>
                    )),
                  )}
                </Grid>
              </Grid>
            )) ||
            null))}
      <DialogCalendario
        open={openEditCalendario}
        handleClose={handleCloseEditCalendario}
        triggerFunction={editCalendarioFunction}
        gara={editCalendario}
      />
      <DialogRisultato
        open={openEditRisultato}
        handleClose={handleCloseEditRisultato}
        triggerFunction={updateRisultato}
        gara={editRisultato}
      />
      <DialogPenalita
        open={openEditPenalita}
        handleClose={handleCloseEditPenalita}
        triggerFunction={updatePenalita}
        gara={editPenalita}
      />
      <DialogOmologa
        open={openEditOmologa}
        handleClose={handleCloseEditOmologa}
        triggerFunction={updateOmologa}
        gara={editOmologa}
      />
      <DialogArbitraggio
        open={openEditArbitraggio}
        handleClose={handleCloseEditArbitraggio}
        triggerFunction={updateArbitraggio}
        gara={editArbitraggio}
      />
      <DialogRipescaggio
        open={openEditRipescaggio}
        handleClose={handleCloseEditRipescaggio}
        triggerFunction={performRipescaggio}
        gara={editRipescaggio}
      />
      <Dialog
        open={openDeleteGara}
        handleClose={handleCloseDeleteGara}
        title={titles.titleDeleteGara}
        textContent={phrases.phraseDeleteGara}
        textUndo='Annulla'
        textConfirm='Ok'
        triggerFunction={deleteGara}
        error
      />
      <DialogIndirizzo
        open={openIndirizzo}
        handleClose={handleCloseIndirizzo}
        gara={garaIndirizzo}
      />
    </Grid>
  )
}

export default Calendari
